module.exports = __webpack_public_path__ + "img/green.baf44a92.svg";